import Vue from 'vue'
import menus from './Menus.vue'
import foot from './Foot.vue'
import home from './Home.vue'
import about from './About.vue'
import documents from './Documents.vue'
import invest from './Invest.vue'
import doing from './Doing.vue'
import news from './News.vue'
import faqs from './Faqs.vue'

new Vue({
  el: '#menus',
  render: h => h(menus)
})
new Vue({
  el: '#foot',
  render: h => h(foot)
})
new Vue({
  el: '#home',
  render: h => h(home)
})
new Vue({
  el: '#about',
  render: h => h(about)
})
new Vue({
  el: '#documents',
  render: h => h(documents)
})
new Vue({
  el: '#invest',
  render: h => h(invest)
})
new Vue({
  el: '#doing',
  render: h => h(doing)
})
new Vue({
  el: '#news',
  render: h => h(news)
})
new Vue({
  el: '#faqs',
  render: h => h(faqs)
})


// WEBPACK FOOTER //
// ./src/main.js